/* src/app/modules/display/components/menus/product-menu/building-blocks/menu-item/product-section-item/product-section-item.component.scss */
::ng-deep .force-italic-style * {
  font-style: italic !important;
}
/*# sourceMappingURL=product-section-item.component.css.map */
